import { render, staticRenderFns } from "./famous.vue?vue&type=template&id=793a2a7e&scoped=true&"
import script from "./famous.vue?vue&type=script&lang=js&"
export * from "./famous.vue?vue&type=script&lang=js&"
import style0 from "./famous.vue?vue&type=style&index=0&id=793a2a7e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a2a7e",
  null
  
)

export default component.exports